import styled from 'styled-components'
import { Button } from '@navent-jobs/ui-kit/components/button'

export const ButtonCustom = styled(Button)`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  @media (min-width: 1024px) {
    margin-bottom: 12px;
  }
`

export const ButtonTitle = styled.div`
  padding-left: 4px;
`
